document.addEventListener('DOMContentLoaded', function () {
  const flickityCarousels = document.querySelectorAll('.flickity-carousel');
  const tabs = document.querySelectorAll('.tab-item');
  const tabsMob = document.querySelectorAll('.tab-item-mob');
  const tabContents = document.querySelectorAll('.collection-tab-content');
  const tabContentsMob = document.querySelectorAll('.collection-tab-content-mob');

  // Fonction pour obtenir le nombre d'éléments visibles
  const getVisibleItems = (carousel) => {
    if (!carousel) return 1; // Valeur par défaut si le carousel n'existe pas
    const dataItemShow = parseInt(carousel.getAttribute("data-items-show"), 10) || 1;
    const dataItemShowMob = parseInt(carousel.getAttribute("data-items-show-mob"), 10) || 1;
    return window.matchMedia("(min-width: 992px)").matches ? dataItemShow : dataItemShowMob;
  };

  // Fonction pour initialiser Flickity
  function initializeFlickity(carousel) {
    if (!carousel) return; // Assurez-vous que le carousel existe
    let flktyInstance = Flickity.data(carousel);

    if (!flktyInstance) {
      flktyInstance = new Flickity(carousel, {
        groupCells: visibleItems,
        cellAlign: 'left', // Aligne les cellules sur le bord gauche
        contain: true, // Assure que le carousel reste dans le viewport
        freeScroll: false, // Désactive le défilement libre pour un meilleur alignement
        wrapAround: false, // Désactive le défilement infini
      });
    }

    const nextButton = carousel.querySelector('.flickity-next');
    const slidesFlickityCarousel = [...carousel.querySelectorAll(".carousel__slide")];

    const updateNextButtonState = (index) => {
      if (!nextButton || slidesFlickityCarousel.length === 0) return; // Vérifie que le bouton et les slides existent
      const visibleItems = getVisibleItems(carousel);
      if (index >= slidesFlickityCarousel.length - visibleItems) {
        nextButton.setAttribute('disabled', 'disabled');
      } else {
        nextButton.removeAttribute('disabled');
      }
    };

    flktyInstance.on('change', () => {
      updateNextButtonState(flktyInstance.selectedIndex);
    });

    updateNextButtonState(flktyInstance.selectedIndex);
  }

  // Gérer les carousels Flickity
  flickityCarousels.forEach(carousel => initializeFlickity(carousel));

  // Fonction pour forcer Flickity à se redimensionner
  const resizeFlickityInTab = (carousel) => {
    const flktyInstance = Flickity.data(carousel);
    if (flktyInstance) {
      flktyInstance.resize(); // Force Flickity à recalculer ses dimensions
    }
  };

  // Gestion des onglets Desktop
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      tabs.forEach((item) => item.classList.remove('active'));
      tabContents.forEach((content) => content.classList.remove('active'));

      const activeTabContent = document.querySelector(`#${tab.getAttribute('data-tab')}`);
      if (activeTabContent) {
        tab.classList.add('active');
        activeTabContent.classList.add('active');

        const carouselInTab = activeTabContent.querySelector('.flickity-carousel');
        if (carouselInTab) {
          resizeFlickityInTab(carouselInTab); // Redimensionne Flickity
          initializeFlickity(carouselInTab); // Réinitialise Flickity
        }
      }
    });
  });

  // Gestion des onglets Mobile
  tabsMob.forEach((tab) => {
    tab.addEventListener('click', () => {
      tabsMob.forEach((item) => item.classList.remove('active'));
      tabContents.forEach((content) => content.classList.remove('active'));

      const activeTabContentMob = document.querySelector(`#${tab.getAttribute('data-tab')}`);
      if (activeTabContentMob) {
        tab.classList.add('active');
        activeTabContentMob.classList.add('active');

        const carouselInTabMob = activeTabContentMob.querySelector('.flickity-carousel');
        if (carouselInTabMob) {
          resizeFlickityInTab(carouselInTabMob); // Redimensionne Flickity
          initializeFlickity(carouselInTabMob); // Réinitialise Flickity
        }
      }
    });
  });

  // Réinitialisation globale pour les changements de taille d'écran
  const resizeCarousels = () => {
    flickityCarousels.forEach((carousel) => {
      resizeFlickityInTab(carousel); // Redimensionne Flickity
    });
  };

  const mediaQuery = window.matchMedia("(min-width: 992px)");
  mediaQuery.addEventListener("change", resizeCarousels);

  // Intersection Observer pour initialiser Flickity quand visible
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const carousel = entry.target.querySelector('.flickity-carousel');
        if (carousel) initializeFlickity(carousel);
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  tabContents.forEach(tabContent => observer.observe(tabContent));
});
